import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { LS_COMPLIANCE_SUBMIT_KEY } from '@/helpers/localStorage';
import IconCheck from './check.svg';
import s from './index.module.scss';

const id = MODAL_IDS.compliance_submit_modal;

export const ComplianceSubmitModal = () => {
  const { modalIds, openSingleModal } = useModal();

  useEffect(() => {
    localStorage.getItem(LS_COMPLIANCE_SUBMIT_KEY) && !modalIds[id] && openSingleModal(id);
  }, [modalIds, openSingleModal]);

  return modalIds[id] && <Modal />;
};

export const Modal = () => {
  const { closeModal } = useModal();
  const { t } = useTranslation('modal');

  const onClose = () => {
    localStorage.removeItem(LS_COMPLIANCE_SUBMIT_KEY);
    closeModal(id);
  };

  return (
    <ModalCenterLayout onClose={onClose} showClose>
      <div className={s.modal}>
        <div className={s.content}>
          <div className={s.icon}>
            <img src={IconCheck} alt="" width={28} height={28} />
          </div>
          <div className={s.title}>{t('compliance_submit_modal.title')}</div>
          <div className={s.desc}>{t('compliance_submit_modal.description')}</div>
        </div>
        <div className={s.footer}>
          <Button
            theme="neutral"
            appearance="filled"
            size="lg"
            label={t('compliance_submit_modal.got_it')}
            onClick={onClose}
          />
        </div>
      </div>
    </ModalCenterLayout>
  );
};
